module.exports = __webpack_public_path__ + "static/media/logo1.beaa5b7f.jpg";